(() => {
  function init(scope) {
    scope.querySelectorAll('.av-tabs').forEach(root => {
      if (root.dataset.avReady) return;
      root.dataset.avReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      function activate(tab, focus) {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
        });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab, false));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
